import { connect } from 'react-redux';
import { useTranslation } from '@eti/providers';
import { concatenateCoverGeniusTexts } from '../../common/utils/coverGeniusApiTexts';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { BANKRUPTCY_INSURANCE_COVER_GENIUS } from '../../products';
import NewSmallCardLayout from '../../common/components/small-card-layout/NewSmallCardLayout';
import { useProductData } from '../../common/hook/useProductData';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = BANKRUPTCY_INSURANCE_COVER_GENIUS;
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POST_BOOKING_LAYOUT
} = ProductCardLayoutType;
const sharedTexts = {
  ipidPolicyLinkText: 'coverGeniusIPIDPolicyLinkText',
  policyLinkText: 'coverGeniusPolicyLinkText',
  readMoreContent: 'bankruptcyInsuranceCoverGeniusAdditionalInformation',
  title: 'bankruptcyInsuranceCoverGeniusTitle'
};
const translations = {
  [MAIN_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'bankruptcyInsuranceCoverGeniusAbstractText',
    upSell: 'bankruptcyInsuranceCoverGeniusUpSellText'
  },
  [POST_BOOKING_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'bankruptcyInsuranceCoverGeniusAbstractText',
    upSell: 'bankruptcyInsuranceCoverGeniusUpSellText'
  },
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'bankruptcyInsuranceCoverGeniusAbstractSmallCard',
    upSell: 'bankruptcyInsuranceCoverGeniusUpSellTextSmallCard'
  }
};
const BankruptcyInsuranceCoverGenius = _ref => {
  let {
    form,
    isSelected,
    order,
    productPosition,
    layoutType = MAIN_CARD_LAYOUT,
    className,
    sellSpecification,
    productSpecificTexts
  } = _ref;
  const {
    t
  } = useTranslation();
  const texts = translations[layoutType] || {};
  const {
    productData,
    rootElement,
    translation: {
      policyLinkText,
      ipidPolicyLinkText,
      readMoreContent,
      abstractContent
    }
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    sellSpecification,
    texts
  });
  if (!productData) {
    return null;
  }
  const {
    disclaimer,
    ipid,
    termsUrl = ''
  } = productSpecificTexts || {};
  const terms = {
    url: termsUrl,
    text: policyLinkText
  };
  const ipidPolicy = {
    url: ipid === null || ipid === void 0 ? void 0 : ipid.url,
    text: ipidPolicyLinkText
  };
  const policyAndIpidContent = concatenateCoverGeniusTexts({
    ipidPolicy,
    terms,
    t,
    layoutType
  });
  const readMoreContentCoverGenius = readMoreContent + concatenateCoverGeniusTexts({
    disclaimer,
    t,
    layoutType
  });
  const isSmallCardLayout = layoutType === ProductCardLayoutType.Small;
  const coverGeniousLinks = isSmallCardLayout ? {
    description: `${abstractContent} ${policyAndIpidContent}`
  } : {
    additionalInformation: policyAndIpidContent
  };
  const updadatedProductData = {
    ...productData,
    ...coverGeniousLinks,
    readMoreContent: readMoreContentCoverGenius
  };
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(NewSmallCardLayout, {
        productData: updadatedProductData,
        ref: rootElement
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: updadatedProductData,
        ref: rootElement
      });
  }
};
const mapStateToProps = (state, _ref2) => {
  let {
    form
  } = _ref2;
  return {
    isSelected: getSelected(BANKRUPTCY_INSURANCE_COVER_GENIUS.name, form)(state)
  };
};
export default connect(mapStateToProps)(BankruptcyInsuranceCoverGenius);
//# sourceMappingURL=BankruptcyInsuranceCoverGenius.js.map